export default __webpack_public_path__ + "static/media/Reader's Cowl of the Effulgent Blade.22e176a6.jpg";